var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadCreationFail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3412 15.0742L12.9912 17.4242",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3412 17.4242L12.9912 15.0742",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1331 9.05768C10.0498 9.04935 9.9498 9.04935 9.85814 9.05768C7.8748 8.99102 6.2998 7.36602 6.2998 5.36602C6.2998 3.32435 7.9498 1.66602 9.9998 1.66602C12.0415 1.66602 13.6998 3.32435 13.6998 5.36602C13.6915 7.36602 12.1165 8.99102 10.1331 9.05768Z",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.1741C8.48333 18.1741 6.975 17.7908 5.825 17.0241C3.80833 15.6741 3.80833 13.4741 5.825 12.1324C8.11667 10.5991 11.875 10.5991 14.1667 12.1324",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadCreationFail);
export default __webpack_public_path__ + "static/media/LeadCreationFail.f5e06c2f93cea1b0ef76005aa49733a3.svg";
export { ForwardRef as ReactComponent };